var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { publishProposal, takeProposalOffline } from '../../Util/ApiService';
import Loader from '../Loader/Loader';
import displayToast from '../../Util/Toast';
import { setCookie } from '../../Util/data';
// Cookie name for proposal publish or sent for approval
const proposalPublishOrSentForApprovalCookie = 'proposalPublishOrSentForApprovalCookie';
const MyPitchesCard = ({ displayModal, hideModal, loadingShareUrls, nudgeCount, packageChooseUrl, pitchEditUrl, proposalExtrasUrl, purchaseNudgesUrl, proposal, publishProposalUrl, selectedProposalToPublish, subscriptionTypeCodes = null, takeOfflineUrl, toggleShareModal }) => {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);
    const [btnTitle, setBtnTitle] = useState(t('myPitches.publish'));
    const [selectedProposalIdToPublish, setSelectedProposalIdToPublish] = useState(null);
    const [isBtnDisabled, setBtnDisabled] = useState(isLoading || !(proposal.publishable || proposal.active));
    const takeProposalLive = (proposalId) => __awaiter(void 0, void 0, void 0, function* () {
        hideModal();
        setIsLoading(true);
        const url = publishProposalUrl.replace('_PROPOSAL_ID_', proposalId.toString());
        try {
            const result = yield publishProposal(url);
            if (result) {
                setCookie(proposalPublishOrSentForApprovalCookie, null, true);
                // Update button to reflect new state but DO NOT disable permanently
                setBtnTitle(t('myPitches.pause'));
            }
            setIsLoading(false);
            setBtnDisabled(true);
        }
        catch (error) {
            displayToast(t('toast.error'), 'error');
            setIsLoading(false);
            setBtnDisabled(true);
        }
    });
    const handleProposalOffline = (proposalId) => __awaiter(void 0, void 0, void 0, function* () {
        setIsLoading(true);
        const url = takeOfflineUrl.replace('_PROPOSAL_ID_', proposalId.toString());
        try {
            const result = yield takeProposalOffline(url);
            if (result) {
                setBtnTitle(t('myPitches.publish'));
            }
            setIsLoading(false);
            setBtnDisabled(true);
        }
        catch (error) {
            displayToast(t('toast.error'), 'error');
            setIsLoading(false);
            setBtnDisabled(true);
        }
    });
    const handlePublishProposal = (proposalId) => {
        if (proposal.proposalCompletePercentage < 100) {
            return displayModal(proposalId, t('proposalDashboard.incompleteFieldsModal.title'));
        }
        takeProposalLive(proposalId);
    };
    const renderDescriptionElement = (title, description, icon, link = '#', hasLink = false, isOutlined = false, customClassNames = '') => {
        return (React.createElement("div", { className: `w-full flex items-center justify-between py-3 ${customClassNames}` },
            React.createElement("div", { className: "flex items-center gap-2" },
                React.createElement("span", { className: `${isOutlined ? 'material-symbols-outlined' : 'material-icons'} text-gray-800 text-2xl"` }, icon),
                hasLink ? (React.createElement("a", { href: link, className: "text-lg leading-6 text-gray-700 underline" }, title)) : (React.createElement("span", { className: "text-lg leading-6 text-gray-700" }, title))),
            React.createElement("p", { className: "text-gray-800 font-semibold text-xl" }, description)));
    };
    useEffect(() => {
        if (proposal) {
            setBtnTitle(proposal.active ? t('myPitches.pause') : t('myPitches.publish'));
        }
    }, [proposal, t]);
    useEffect(() => {
        setSelectedProposalIdToPublish(selectedProposalToPublish);
        if (selectedProposalIdToPublish &&
            selectedProposalIdToPublish === proposal.proposalId) {
            takeProposalLive(selectedProposalIdToPublish);
        }
    }, [selectedProposalToPublish]);
    return (React.createElement("div", { key: proposal.proposalId, className: "bg-white w-full shadow-md p-6 flex flex-col gap-12" },
        React.createElement("div", { className: "w-full flex items-start justify-between" },
            React.createElement("div", { className: "flex md:items-center items-start gap-6 md:flex-row flex-col" },
                React.createElement("img", { src: proposal.logoUri, alt: proposal.title, className: "w-16 h-16 shrink-0 rounded-lg object-cover object-center" }),
                React.createElement("h3", { className: "text-gray-800 font-semibold md:text-2xl text-xl leading-8" }, proposal.title)),
            React.createElement("div", { className: "flex items-center gap-2 justify-end md:relative absolute right-10 md:right-0" },
                React.createElement("button", { onClick: () => {
                        return toggleShareModal(proposal.proposalId);
                    }, disabled: loadingShareUrls, type: "button", className: "w-10 h-10 shrink-0 rounded-md text-gray-800 bg-gray-200 hover:bg-gray-300 focus:outline-none hidden md:inline-flex items-center justify-center disabled:cursor-not-allowed" }, loadingShareUrls ? (React.createElement(Loader, { customColor: "text-gray-800", title: t('auth.inbox.loading') })) : (React.createElement("span", { className: "material-icons text-xl" }, "share"))),
                React.createElement("a", { href: proposal.proposalUri, className: "w-10 h-10 shrink-0 rounded-md text-gray-800 bg-gray-200 hover:bg-gray-300 focus:outline-none inline-flex items-center justify-center" },
                    React.createElement("span", { className: "material-icons text-xl" }, "visibility")),
                React.createElement("a", { href: pitchEditUrl.replace('_PROPOSAL_ID_', proposal.proposalId.toString()), className: "w-10 h-10 shrink-0 rounded-md text-gray-700 bg-gray-200 hover:bg-gray-300 focus:outline-none inline-flex items-center justify-center" },
                    React.createElement("span", { className: "material-icons text-xl" }, "edit")),
                React.createElement("button", { type: "button", disabled: isBtnDisabled, onClick: () => {
                        return proposal.active
                            ? handleProposalOffline(proposal.proposalId)
                            : handlePublishProposal(proposal.proposalId);
                    }, className: `${isLoading ? 'w-10 h-10' : ''} bg-blue-600 hover:bg-blue-500 text-white py-2 px-4 inline-flex items-center justify-center text-center text-base leading-6 font-semibold rounded-md transition-all disabled:opacity-50 disabled:cursor-not-allowed` }, isLoading ? React.createElement(Loader, { title: t('auth.inbox.loading') }) : btnTitle))),
        React.createElement("div", { className: "grid md:grid-cols-2 grid-cols-1 md:gap-16" },
            React.createElement("div", { className: "w-full flex flex-col md:divide-y divide-gray-300" },
                renderDescriptionElement(t('myPitches.progress'), `${proposal.proposalCompletePercentage}% ${t('myPitches.complete')}`, 'av_timer', pitchEditUrl.replace('_PROPOSAL_ID_', proposal.proposalId.toString()), true, false, 'md:border-0 border-b border-gray-300'),
                renderDescriptionElement(t('myPitches.package'), proposal.subscriptionType.code ===
                    (subscriptionTypeCodes === null || subscriptionTypeCodes === void 0 ? void 0 : subscriptionTypeCodes.novicePlus) ||
                    proposal.subscriptionType.code === null
                    ? '-'
                    : proposal.subscriptionType.name, 'business_center', packageChooseUrl.replace('_PROPOSAL_ID_', proposal.proposalId.toString()), true, false, 'md:border-0 border-b border-gray-300'),
                renderDescriptionElement(t('myPitches.status'), proposal.active
                    ? t('myPitches.approved')
                    : proposal.pendingApproval
                        ? t('myPitches.pendingApproval')
                        : proposal.expired
                            ? t('myPitches.expired')
                            : t('myPitches.draft'), 'insert_emoticon', '#', false, false, 'md:border-0 border-b border-gray-300')),
            React.createElement("div", { className: "w-full flex flex-col divide-y divide-gray-300" },
                renderDescriptionElement(t('myPitches.nudges'), nudgeCount, 'handshake', purchaseNudgesUrl, true, true),
                renderDescriptionElement(t('myPitches.boosters'), proposal.boosterCount, 'rocket_launch', proposalExtrasUrl.replace('_PROPOSAL_ID_', proposal.proposalId.toString()), true, true)))));
};
export default MyPitchesCard;
